import { MyHealer } from '../../core/models/my-healer';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface ClientMyHealersState {
  myHealersInfo?: MyHealer[];
  loadingDataError?: string;
  selectedHealer?: MyHealer;
  selectedHealerPackageId?: string;
  showPackageDetailsPopup: boolean;
}

export const initialClientMyHealersState = () =>
  ({
    myHealersInfo: undefined,
    loadingDataError: undefined,
    showPackageDetailsPopup: false,
  } as ClientMyHealersState);

export interface ClientMyHealersAction {
  type:
    | 'LOAD_MY_HEALERS_SUCCESS'
    | 'LOAD_MY_HEALERS_FAILURE'
    | 'SET_SELECTED_HEALER'
    | 'SET_SELECTED_HEALER_PACKAGE'
    | 'SHOW_PACKAGE_DETAILS_POPUP'
    | 'HIDE_PACKAGE_DETAILS_POPUP';
  payload?: any;
}

const clientMyHealersReducer = (state: ClientMyHealersState = initialClientMyHealersState(), action: ClientMyHealersAction): ClientMyHealersState => {
  switch (action.type) {
    case 'LOAD_MY_HEALERS_SUCCESS':
      return {
        ...state,
        myHealersInfo: action.payload,
      };
    case 'LOAD_MY_HEALERS_FAILURE':
      return { ...state, loadingDataError: extractMessageFromError(action.payload) };
    case 'SET_SELECTED_HEALER': {
      const selectedHealerId = action.payload;
      if (selectedHealerId === undefined) {
        return { ...state, selectedHealer: undefined, selectedHealerPackageId: undefined };
      }
      const selectedHealer = state.myHealersInfo?.find((healer) => healer.id === selectedHealerId);
      const selectedHealerPackageId = selectedHealer?.packages[0]?.id;
      return {
        ...state,
        selectedHealer,
        selectedHealerPackageId,
      };
    }
    case 'SET_SELECTED_HEALER_PACKAGE': {
      const selectedHealerPackageId = action.payload;
      return {
        ...state,
        selectedHealerPackageId: selectedHealerPackageId,
      };
    }
    case 'SHOW_PACKAGE_DETAILS_POPUP': {
      return {
        ...state,
        showPackageDetailsPopup: true,
      };
    }
    case 'HIDE_PACKAGE_DETAILS_POPUP': {
      return {
        ...state,
        showPackageDetailsPopup: false,
      };
    }
    default:
      return state;
  }
};

export default clientMyHealersReducer;
